if (!customElements.get("ff-header-drawer")) {
  /**
   * This extension of HeaderDrawer is meant to change the flow of the menu,
   * to implement the FfCollapsable for the menu groups.
   * 
   * FLOW TO REMOVE IPHONE SCROLL 
   * block pointer and touch-actions in the whole page
   * animate the opening of menu
   * change the body to fixed position and give it a negative transform to hide the announcement bar
   * enable pointer and touch-actions in ff-header-drawer
   */
  class FfMenuDrawer extends HeaderDrawer {
    constructor() {
      super();
      this.collapsables = this.querySelectorAll("ff-collapsable");
      this.ffBindedBlock = this.ffBlockScroll.bind(this);

      this.querySelector("#menu-drawer").addEventListener("transitionstart", () => this.transitionStart = true)
    }

    closeAnimation(detailsElement) {
      const collapsableContainer = detailsElement.querySelector(
        ".ff-facet_collapsable-container"
      );
      if (collapsableContainer && this.mainDetailsToggle != detailsElement) {
        collapsableContainer.removeEventListener("transitionend", closeFacet);
        collapsableContainer.addEventListener("transitionend", closeFacet);

        function closeFacet() {
          collapsableContainer.removeEventListener("transitionend", closeFacet);

          detailsElement.removeAttribute("open");
          if (detailsElement.closest("details[open]")) {
            trapFocus(
              detailsElement.closest("details[open]"),
              detailsElement.querySelector("summary")
            );
          }
        }
      } else {
        let animationStart;
        const handleAnimation = (time) => {
          if (animationStart === undefined) {
            animationStart = time;
          }

          const elapsedTime = time - animationStart;

          if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            detailsElement.removeAttribute("open");
            if (detailsElement.closest("details[open]")) {
              trapFocus(
                detailsElement.closest("details[open]"),
                detailsElement.querySelector("summary")
              );
            }
            setTimeout(() => {
              document.body.classList.remove(
                `overflow-hidden-${this.dataset.breakpoint}`
              );
            }, 100);
          }
        };

        window.requestAnimationFrame(handleAnimation);
      }
    }

    /**
     * The original closeMenuDrawer was also closing all the opened details elements,
     * in FfMenuDrawer that is done in the method onSmmaryClick instead.
     */
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove("menu-opening");
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);

        if (event instanceof KeyboardEvent)
          elementToFocus?.setAttribute("aria-expanded", false);
      }, 100);
    }

    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        if (this.transitionStart) {
          this.querySelector("#menu-drawer").removeEventListener(
            "transitionend",
            this.ffBindedBlock
          );
          this.querySelector("#menu-drawer").addEventListener(
            "transitionend",
            this.ffBindedBlock
          );
          this.transitionStart = false;
        } else {
          this.ffBindedBlock();
        }
        super.openMenuDrawer(summaryElement);
      }, 10)
    }

    ffBlockScroll() {
      this.classList.add("ff-enable-pointer");
      this.querySelector("#menu-drawer").removeEventListener(
        "transitionend",
        this.ffBindedBlock
      );
      // const pageScrollBackUp = document.querySelector("html").scrollTop;
      // if (pageScrollBackUp > 0) {
      //   this.pageScrollBackUp = pageScrollBackUp;
      //   const { offsetHeight } = document.querySelector(".ff-announcement_bar");
      //   this.bodyPositionBackUp = document.body.style.position;
      //   this.bodyTransformBackUp = document.body.style.transform;
      //   document.body.style.position = "fixed";
      //   document.body.style.transform = `translateY(-${offsetHeight}px)`;
      // }
    }

    ffResumeScroll() {
      this.classList.remove("ff-enable-pointer");
      if (this.pageScrollBackUp > 0) {
        document.body.style.position = this.bodyPositionBackUp;
        document.body.style.transform = this.bodyTransformBackUp;
        document.querySelector("html").scrollTop = this.pageScrollBackUp;
        this.pageScrollBackUp = 0;
      }
    }

    onSummaryClick(e) {
      this.ffCloseCollapsables();
      super.onSummaryClick(e);
      this.querySelector(".menu-drawer__navigation-container").scrollTo(0, 0);
    }

    ffCloseCollapsables() {
      this.collapsables.forEach((collapsable) => {
        const closeBtn = collapsable.querySelector(".ff-close-facet");
        if (collapsable.isOpened && closeBtn) {
          closeBtn.click();
        }
      });
    }

  }

  customElements.define("ff-header-drawer", FfMenuDrawer);
}
